import { createFileRoute, Outlet } from '@tanstack/react-router'
import { z } from 'zod'
import { tasksQueryOptions } from '@/features/tasks/api'
import { taskFilterSchema } from '@/features/tasks/model/task-view'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/tasks')({
  staticData: { scrollPage: true },
  validateSearch: z.object({ filter: taskFilterSchema.optional().catch(undefined) }),
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(tasksQueryOptions(params.workspaceSlug)),
  component: Outlet,
})
